import { LanguageType } from "@/custom-types";
import { BedSizeOption } from "@/graphql/generated";

export const bedSizeMapper = (option: BedSizeOption, language: LanguageType) => {
  const optionMap = {
    en: {
      TWIN: 'Twin / 96 x 191cm',
      TWIN_XL: 'TwinXL / 96 x 203cm',
      DOUBLE: 'Double / 137 x 191cm',
      QUEEN: 'Queen / 152 x 203cm',
      KING: 'King / 193 x 203',
    },
    es: {
      TWIN: 'Individual / 96 x 191cm',
      TWIN_XL: 'Individual XL / 96 x 203cm',
      DOUBLE: 'Doble / 137 x 191cm',
      QUEEN: 'Queen / 152 x 203cm',
      KING: 'King / 193 x 203',
    },
  }

  return optionMap[language][option]
}

